<template>
  <x-page title="">
    <XOrderSwitcher slot="title" />

    <x-sticky>
      <van-tabs
        v-model="currentCategoryIndex"
        :class="_.tabs"
        title-active-color="rgba(255, 17, 28, 1)"
        @click="
          index =>
            $track.push({
              name: '我的订单-分类栏',
              content: categoryList[index].label,
              id: '3d14e2c4-85c4-44f2-bc80-e0f4ea73481a',
            })
        "
      >
        <van-tab
          v-for="cat in categoryList"
          :key="cat.value"
          :title="cat.label"
        />
      </van-tabs>
    </x-sticky>

    <x-swipeable-view
      :index="currentCategoryIndex"
      :total="categoryList.length"
      @swipe="({ index }) => (currentCategoryIndex = index)"
    >
      <div :class="_.list">
        <x-waterfall
          ref="list"
          no-complete-tips
          primary-key="orderId"
          :load="handleLoad"
          :check="handleCheck"
        >
          <template #default="{ data, record, checkRecord }">
            <OrderItem
              v-for="item in data"
              :key="item.orderId"
              :item="item"
              @click="() => record(item.orderId)"
              @refresh="reloadList"
              @countdownend="checkRecord(item.orderId, 2000)"
            />
          </template>
          <x-empty slot="empty" type="列表" message="暂时没有订单哦~" />
          <x-goods-recommend
            v-if="$globalModel.state.channelIsShowDcbResource"
            slot="extra"
            resource-position-id="8aaa8ac37b113694017b1143da8d001a"
            :top="0"
          />
        </x-waterfall>
      </div>
    </x-swipeable-view>
  </x-page>
</template>

<script>
  import OrderItem from './components/order_item'
  import Vue from 'vue'
  import { apiGroupBuyingOrderList } from '@/api'
  import { mapQuery, Track } from '@/utils'

  export default Vue.extend({
    components: {
      OrderItem,
    },

    mixins: [
      mapQuery({
        active: 'active',
      }),
      Track.provideMark(() => ({
        page: '拼团-我的订单',
      })),
    ],

    data() {
      return {
        // 当前分类索引
        currentCategoryIndex: 0,

        // 分类列表
        categoryList: [
          {
            label: '全部',
            value: 0,
            status: undefined,
          },
          {
            label: '待付款',
            value: 1,
            status: 0,
          },
          {
            label: '待成团',
            value: 2,
            status: 2,
          },
          {
            label: '拼团成功',
            value: 3,
            status: 3,
          },
          {
            label: '拼团失败',
            value: 4,
            status: 4,
          },
        ],
      }
    },

    watch: {
      currentCategoryIndex() {
        this.reloadList()
      },
    },

    created() {
      this.currentCategoryIndex = +(this.active || 0)
    },

    methods: {
      // 重载列表
      async reloadList() {
        await this.$refs.list.reload()
      },

      // 加载列表
      handleLoad({ pageNumber }) {
        return apiGroupBuyingOrderList({
          pageIndex: pageNumber,
          pageSize: 10,
          orderStatus: this.categoryList[this.currentCategoryIndex].status,
        })
      },

      // 检查订单
      async handleCheck(item) {
        const {
          list: [newItem],
        } = await apiGroupBuyingOrderList({
          pageIndex: 1,
          pageSize: 1,
          orderStatus: this.categoryList[this.currentCategoryIndex].status,
          orderId: item.orderId,
        })
        return newItem
      },
    },
  })
</script>

<style lang="scss" module>
  .tabs {
    z-index: 1;
  }

  .list {
    padding: 12px;
  }
</style>
